// ===========================================
// utils/constants.js
// ===========================================
export const TABS = {
  LIBRARY: 'library',
  UPLOAD: 'upload',
  ADMIN: 'admin'
};

export const SORT_OPTIONS = {
  RELEVANCE: 'relevance',
  TITLE: 'title',
  AUTHOR: 'author',
  DATE_DESC: 'date_desc',
  DATE_ASC: 'date_asc',
  DOWNLOADS: 'downloads'
};

export const FILTER_TYPES = {
  AUTHOR: 'author',
  UPLOAD_DATE: 'uploadDate',
  FILE_SIZE: 'fileSize'
};

export const PAGINATION_CONFIG = {
  BOOKS_PER_PAGE: 50,             // Fixed 50 books per page
  LOAD_MORE_THRESHOLD: '100px'    // Distance from bottom to trigger load
};